export default "__VITE_ASSET__f7533c08__"